export default function SpeakerIcon() {
  return (
    <>
      <path
        d='M12.5 6.67188C13.0175 7.05999 13.4375 7.56325 13.7268 8.14182C14.0161 8.72038 14.1667 9.35835 14.1667 10.0052C14.1667 10.6521 14.0161 11.29 13.7268 11.8686C13.4375 12.4472 13.0175 12.9504 12.5 13.3385'
        fill='none'
      />
      <path
        d='M14.75 4.17188C15.62 4.87492 16.3217 5.76365 16.8037 6.77298C17.2858 7.78231 17.536 8.88668 17.536 10.0052C17.536 11.1237 17.2858 12.2281 16.8037 13.2374C16.3217 14.2468 15.62 15.1355 14.75 15.8385'
        fill='none'
      />
      <path
        d='M5 12.5021H3.33333C3.11232 12.5021 2.90036 12.4143 2.74408 12.2581C2.5878 12.1018 2.5 11.8898 2.5 11.6688V8.33547C2.5 8.11445 2.5878 7.90249 2.74408 7.74621C2.90036 7.58993 3.11232 7.50213 3.33333 7.50213H5L7.91667 3.75213C7.9895 3.61066 8.11054 3.4999 8.25791 3.43988C8.40528 3.37985 8.56925 3.37452 8.72021 3.42484C8.87117 3.47516 8.99915 3.57781 9.08103 3.71425C9.16291 3.85069 9.19328 4.01192 9.16667 4.1688V15.8355C9.19328 15.9923 9.16291 16.1536 9.08103 16.29C8.99915 16.4265 8.87117 16.5291 8.72021 16.5794C8.56925 16.6298 8.40528 16.6244 8.25791 16.5644C8.11054 16.5044 7.9895 16.3936 7.91667 16.2521L5 12.5021Z'
        fill='none'
      />
    </>
  );
}
